import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e1b4f516"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "team-result-intermiadiate-block ms-auto"
}
const _hoisted_2 = { class: "d-flex justify-content-md-end" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 1,
  style: {"margin-left":"3rem"}
}
const _hoisted_5 = {
  key: 2,
  class: "me-3 ms-3"
}
const _hoisted_6 = { class: "fs-7 text-uppercase" }
const _hoisted_7 = { class: "d-flex mt-1" }
const _hoisted_8 = { class: "fw-bold" }
const _hoisted_9 = {
  key: 0,
  class: "fw-normal small mt-1"
}
const _hoisted_10 = { key: 3 }
const _hoisted_11 = { class: "fs-7 text-uppercase" }
const _hoisted_12 = {
  key: 0,
  class: "d-flex mt-1"
}
const _hoisted_13 = {
  key: 1,
  class: "d-flex mt-1",
  style: {"margin-top":"0.2em"}
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "fs-6 mx-2" }, "-", -1))
const _hoisted_15 = { style: {"margin-left":"4rem"} }
const _hoisted_16 = {
  key: 0,
  class: "d-flex justify-content-md-end mt-4"
}
const _hoisted_17 = { class: "left-result" }
const _hoisted_18 = {
  key: 0,
  class: "fs-6 fw-bold text-dark"
}
const _hoisted_19 = {
  key: 1,
  class: "fs-6 align-items-md-end"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "fs-6 mx-2 fw-normal" }, "vs", -1))
const _hoisted_21 = { class: "right-result d-flex" }
const _hoisted_22 = {
  key: 0,
  class: "fs-6 fw-normal"
}
const _hoisted_23 = {
  key: 1,
  class: "fs-6 fw-bold text-dark"
}
const _hoisted_24 = {
  key: 1,
  class: "d-flex justify-content-md-end mt-1"
}
const _hoisted_25 = { class: "fs-6 text-capitalize" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ResultMedal = _resolveComponent("ResultMedal")!
  const _component_MrUiKitInputMask = _resolveComponent("MrUiKitInputMask")!

  return (_ctx.otherResult != null)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.otherResult.position && _ctx.otherResult.position <= 3)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_ResultMedal, {
                  position: _ctx.otherResult.position,
                  class: "mt-2 me-3 ms-2"
                }, null, 8, ["position"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.otherResult.position && _ctx.otherResult.position > 3)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4))
            : _createCommentVNode("", true),
          (_ctx.otherResult.position)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.t("result.position")), 1),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("h4", _hoisted_8, _toDisplayString(_ctx.otherResult.position) + "º", 1),
                  (_ctx.otherResult.totPartecipant)
                    ? (_openBlock(), _createElementBlock("h4", _hoisted_9, " / " + _toDisplayString(_ctx.otherResult.totPartecipant), 1))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.otherResult.competitionResultType)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.otherResult.competitionResultType.name), 1),
                (!_ctx.otherResult.competitionResultType.haveDoubleResult)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createVNode(_component_MrUiKitInputMask, {
                        classes: ['mb-0'],
                        modelValue: _ctx.otherResult.leftResult,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.otherResult.leftResult) = $event)),
                        mask: _ctx.otherResult.competitionResultType.regex,
                        disabled: true
                      }, null, 8, ["modelValue", "mask"])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createElementVNode("h4", null, _toDisplayString(_ctx.otherResult.leftResult), 1),
                      _hoisted_14,
                      _createElementVNode("h4", null, _toDisplayString(_ctx.otherResult.rightResult), 1)
                    ]))
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_15, [
          (
          _ctx.otherResult.competitionResultType &&
          _ctx.otherResult.competitionResultType.haveDoubleResult
        )
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  (_ctx.otherResult.isLeft)
                    ? (_openBlock(), _createElementBlock("h4", _hoisted_18, _toDisplayString(_ctx.otherResult.entity), 1))
                    : (_openBlock(), _createElementBlock("h4", _hoisted_19, _toDisplayString(_ctx.otherResult.opponent), 1))
                ]),
                _hoisted_20,
                _createElementVNode("div", _hoisted_21, [
                  (_ctx.otherResult.isLeft)
                    ? (_openBlock(), _createElementBlock("h4", _hoisted_22, _toDisplayString(_ctx.otherResult.opponent), 1))
                    : (_openBlock(), _createElementBlock("h4", _hoisted_23, _toDisplayString(_ctx.otherResult.entity), 1))
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.otherResult.notes)
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.otherResult.notes), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}